
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const FeedPage = lazy(() => import('../pages/feed/page'));
const ExplorePage = lazy(() => import('../pages/explore/page'));
const UploadPage = lazy(() => import('../pages/upload/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ChildrenPage = lazy(() => import('../pages/children/page'));
const AdultsPage = lazy(() => import('../pages/adults/page'));
const SeniorsPage = lazy(() => import('../pages/seniors/page'));
const VideoChildrenPage = lazy(() => import('../pages/video-children/page'));
const VideoAdultsPage = lazy(() => import('../pages/video-adults/page'));
const VideoSeniorsPage = lazy(() => import('../pages/video-seniors/page'));
const AdminUploadPage = lazy(() => import('../pages/admin-upload/page'));
const CaseUVDemoPage = lazy(() => import('../pages/case-uv-demo/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/feed',
    element: <FeedPage />,
  },
  {
    path: '/explore',
    element: <ExplorePage />,
  },
  {
    path: '/upload',
    element: <UploadPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/children',
    element: <ChildrenPage />,
  },
  {
    path: '/adults',
    element: <AdultsPage />,
  },
  {
    path: '/seniors',
    element: <SeniorsPage />,
  },
  {
    path: '/video/children/:id',
    element: <VideoChildrenPage />,
  },
  {
    path: '/video/adults/:id',
    element: <VideoAdultsPage />,
  },
  {
    path: '/video/seniors/:id',
    element: <VideoSeniorsPage />,
  },
  {
    path: '/admin-upload',
    element: <AdminUploadPage />,
  },
  {
    path: '/case-uv-demo',
    element: <CaseUVDemoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
